import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import PrintIcon from '@material-ui/icons/Print';
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import PersonIcon from '@material-ui/icons/Person';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import CropFreeIcon from '@material-ui/icons/CropFree';
import {
  TOUR_PENDING_KEY,
  DUP_MERGE_EVENT,
  driverPrintedIndicator,
  driverDupWarning,
  driverDupMerge,
  driverDiscontinue,
  driverBulkPrice,
  driverQueueQuantity,
  driverMultiSampleCheckout,
} from '../Shared/WhatsNew/tours';

const ONBOARDING_IS_ADMIN_KEY = 'onboardingIsAdmin';

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2) },
  headCell: {
    backgroundColor: '#4DB6D4',
    color: '#fff',
    fontWeight: 700,
    fontSize: 13,
    padding: '8px 12px',
    borderBottom: 'none',
  },
  cell: { fontSize: 13, padding: '8px 12px' },
  iconCell: { whiteSpace: 'nowrap', padding: '6px 8px' },
  evenRow: { backgroundColor: '#fafafa' },
  mockToolbar: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 2,
    padding: '10px 20px',
    fontSize: 14,
  },
  mockDivider: {
    width: 2,
    alignSelf: 'stretch',
    background: '#000',
    margin: '0 50px',
  },
  queueLabel: {
    color: '#6b6b6b',
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    marginRight: 6,
    whiteSpace: 'nowrap',
  },
  qtyChip: {
    minWidth: 24,
    textAlign: 'center',
    fontSize: 13,
    fontWeight: 700,
    border: '1px solid #d8d8d8',
    borderRadius: 10,
    padding: '1px 6px',
    background: '#fff',
  },
  bulkBar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 8,
    padding: '10px 12px',
    marginBottom: 8,
    background: '#f6f6f6',
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    fontSize: 13,
  },
  // merge dialog
  scoreBar: { display: 'flex', gap: 8, padding: '0 0 16px', flexWrap: 'wrap' },
  scoreChip: {
    background: '#2e7d32',
    color: '#fff',
    borderRadius: 12,
    padding: '3px 12px',
    fontSize: 12,
    fontWeight: 700,
  },
  scoreLabel: { fontWeight: 400, marginRight: 4, opacity: 0.85 },
  cardSelected: { border: '2px solid #1976d2 !important' },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '12px 16px',
    color: '#fff',
  },
  fieldRow: { padding: '6px 0', borderBottom: '1px solid #f0f0f0' },
  fieldLabel: { fontSize: 11, color: '#999', marginBottom: 2 },
  dialogTitle: {
    background: '#142E3E',
    color: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

const COLUMNS = [
  { key: 'manufacturer',  label: 'Manufacturer' },
  { key: 'distributor',   label: 'Distributor' },
  { key: 'privateName',   label: 'Private Style Name' },
  { key: 'styleName',     label: 'Style Name' },
  { key: 'styleNum',      label: 'Style Number' },
  { key: 'matClass',      label: 'Material Class' },
  { key: 'matSubClass',   label: 'Material Sub Class' },
  { key: 'size',          label: 'Size' },
  { key: 'backing',       label: 'Backing' },
];

const MOCK_PRODUCTS = [
  {
    id: '1', manufacturer: 'DALTILE', distributor: 'DALTILE', privateName: '',
    styleName: "P'ZAZZ FIELD TILE FLOOR 12X12 GROUP 1", styleNum: '0880',
    matClass: 'CERAMIC TILE', matSubClass: '', size: '12X12', backing: '',
    hasPrinted: true, hasDuplicate: true, dupScore: 100,
  },
  {
    id: '2', manufacturer: 'DALTILE', distributor: 'DALTILE', privateName: '',
    styleName: "P'ZAZZ FIELD TILE FLOOR 12X12 GROUP 2", styleNum: '0880',
    matClass: 'CERAMIC TILE', matSubClass: '', size: '12X12', backing: '',
    hasPrinted: false, hasDuplicate: true, dupScore: 100,
  },
  {
    id: '3', manufacturer: 'SHAW', distributor: 'SHAW', privateName: '',
    styleName: 'DISTINCTION HARDWOOD OAK NATURAL', styleNum: '5000',
    matClass: 'HARDWOOD', matSubClass: '', size: '3.25"', backing: '',
    hasPrinted: false, hasDuplicate: false,
  },
  {
    id: '4', manufacturer: 'MOHAWK', distributor: 'MOHAWK', privateName: '',
    styleName: 'REVWOOD PLUS DOGWOOD RIDGE', styleNum: 'REV-01',
    matClass: 'LAMINATE', matSubClass: '', size: '5"', backing: '',
    hasPrinted: false, hasDuplicate: false,
  },
];

// Stand-in for the expanded panel of the first product row, so the discontinue
// tour has something on screen to point at (the real controls only exist once a
// live search result is expanded).
const MOCK_OPTIONS = [
  { sku: '0880-1212', color: 'ARCTIC WHITE', price: '$3.29', override: '6.99', uom: 'SF', discontinued: false },
  { sku: '0880-1213', color: 'DESERT GRAY',  price: '$3.29', override: '6.99', uom: 'SF', discontinued: false },
  { sku: '0880-1214', color: 'SLATE BLUE',   price: '$3.49', override: '7.49', uom: 'SF', discontinued: true, endDate: '2026-04-30' },
];

// Right-hand table of the mock sample checkout dialog.
const MOCK_CHECKOUTS = [
  { name: 'Denise Okafor',   location: 'Plano Showroom', color: 'Coastal Grey',           status: 'Checked Out', days: 3 },
  { name: 'Ray Benavides',   location: 'Plano Showroom', color: 'General Product Sample', status: 'Pending',     days: 1 },
  { name: 'Marla Whitfield', location: 'Plano Showroom', color: 'Natural Hickory',        status: 'Returned',    days: 12 },
];

const MERGE_SCORES = [
  ['Overall', 100], ['Style #', 100], ['Name', 98], ['Mfg', 100], ['Size', 95],
];

const PRODUCT_A_FIELDS = [
  ['Style Name',     "P'ZAZZ FIELD TILE FLOOR 12X12 GROUP 1"],
  ['Style Number',   '0880'],
  ['Distributor',    'DALTILE'],
  ['Material Class', 'CERAMIC TILE'],
  ['Size',           '12X12'],
];

const PRODUCT_B_FIELDS = [
  ['Style Name',     "P'ZAZZ FIELD TILE FLOOR 12X12 GROUP 2"],
  ['Style Number',   '0880'],
  ['Distributor',    'DALTILE'],
  ['Material Class', 'CERAMIC TILE'],
  ['Size',           '12X12'],
];

export default function TourProductsPage() {
  const classes = useStyles();
  const history = useHistory();
  const [dupDialogOpen, setDupDialogOpen] = useState(false);
  const [checkoutDialogOpen, setCheckoutDialogOpen] = useState(false);
  const afterDoneRef = useRef(null);

  // Start the appropriate driver when this page mounts
  useEffect(() => {
    const key = sessionStorage.getItem(TOUR_PENDING_KEY);

    if (key === 'tour-printed') {
      sessionStorage.removeItem(TOUR_PENDING_KEY);
      setTimeout(() => driverPrintedIndicator(history), 500);

    } else if (key === 'tour-dup-product') {
      sessionStorage.removeItem(TOUR_PENDING_KEY);
      // What's New tour — after merge dialog, go home
      setTimeout(() => driverDupWarning(history, null), 500);

    } else if (key === 'onboarding-dup-product') {
      sessionStorage.removeItem(TOUR_PENDING_KEY);
      // Onboarding tour — after merge dialog, continue to settings or lead management
      const isAdmin = sessionStorage.getItem(ONBOARDING_IS_ADMIN_KEY) === '1';
      const afterDone = () => {
        if (isAdmin) {
          sessionStorage.setItem(TOUR_PENDING_KEY, 'onboarding-settings');
          history.push('/settings');
        } else {
          sessionStorage.setItem(TOUR_PENDING_KEY, 'onboarding-lead');
          history.push('/lead-management');
        }
      };
      setTimeout(() => driverDupWarning(history, afterDone), 500);

    } else if (key === 'tour-discontinue') {
      sessionStorage.removeItem(TOUR_PENDING_KEY);
      setTimeout(() => driverDiscontinue(history), 500);

    } else if (key === 'tour-bulk-price') {
      sessionStorage.removeItem(TOUR_PENDING_KEY);
      setTimeout(() => driverBulkPrice(history), 500);

    } else if (key === 'tour-queue-quantity') {
      sessionStorage.removeItem(TOUR_PENDING_KEY);
      setTimeout(() => driverQueueQuantity(history), 500);

    } else if (key === 'tour-multi-sample') {
      sessionStorage.removeItem(TOUR_PENDING_KEY);
      // Open the mock checkout dialog first, then highlight inside it — same
      // sequence the merge dialog uses below.
      setCheckoutDialogOpen(true);
      setTimeout(() => driverMultiSampleCheckout(history, () => setCheckoutDialogOpen(false)), 500);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Listen for the event dispatched by driverDupWarning when user clicks Next
  useEffect(() => {
    function handleOpen(e) {
      const rawAfterDone = e.detail.afterDone;
      // Wrap so the dialog is closed before continuing the tour
      const wrappedAfterDone = () => {
        setDupDialogOpen(false);
        if (rawAfterDone) {
          rawAfterDone();
        } else {
          sessionStorage.setItem(TOUR_PENDING_KEY, 'tour-complete');
          history.push('/home');
        }
      };
      afterDoneRef.current = wrappedAfterDone;
      setDupDialogOpen(true);
      setTimeout(() => driverDupMerge(history, wrappedAfterDone), 400);
    }
    window.addEventListener(DUP_MERGE_EVENT, handleOpen);
    return () => window.removeEventListener(DUP_MERGE_EVENT, handleOpen);
  }, [history]);

  return (
    <div className={classes.root}>
      {/* ── Product list table ── */}
      <Paper elevation={2} style={{ borderRadius: 8, overflow: 'hidden' }}>
        <div style={{ padding: '14px 20px', backgroundColor: '#142E3E' }}>
          <Typography variant="h4" style={{ color: '#fff' }}>Product List</Typography>
        </div>

        {/* Selection toolbar — stand-in for the real one, so the print-queue tour
            has something to highlight. */}
        <div className={classes.mockToolbar} id="tour-mock-queue-add">
          <span style={{ fontWeight: 600 }}>3 selected</span>
          <span className={classes.mockDivider} />
          <span className={classes.queueLabel}>Copies each</span>
          <IconButton size="small" disableRipple style={{ color: '#ff682c', padding: 4 }}>
            <RemoveIcon fontSize="inherit" />
          </IconButton>
          <span className={classes.qtyChip} style={{ width: 42 }}>2</span>
          <IconButton size="small" disableRipple style={{ color: '#ff682c', padding: 4 }}>
            <AddIcon fontSize="inherit" />
          </IconButton>
          <Button
            variant="contained"
            disableRipple
            startIcon={<PrintIcon />}
            style={{ marginLeft: 10, backgroundColor: '#eeeeee', color: '#ff682c' }}
          >
            ADD 6 LABELS
          </Button>
          <Button
            variant="contained"
            disableRipple
            style={{ marginLeft: 50, backgroundColor: '#eeeeee', color: '#ff682c' }}
          >
            MERGE OPTIONS
          </Button>
        </div>

        <TableContainer>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell className={classes.headCell} padding="checkbox">
                  <Checkbox style={{ color: 'rgba(255,255,255,0.5)' }} disabled size="small" />
                </TableCell>
                <TableCell className={classes.headCell}>More Details</TableCell>
                {COLUMNS.map((c) => (
                  <TableCell key={c.key} className={classes.headCell}>{c.label}</TableCell>
                ))}
                <TableCell className={classes.headCell}>Update</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {MOCK_PRODUCTS.map((p, i) => (
                <TableRow key={p.id} className={i % 2 === 1 ? classes.evenRow : ''}>
                  <TableCell padding="checkbox" className={classes.cell}>
                    <Checkbox disabled size="small" />
                  </TableCell>
                  <TableCell className={classes.iconCell}>
                    <IconButton
                      id={p.id === '1' ? 'tour-mock-expand-row' : undefined}
                      size="small"
                      disabled
                    >
                      <KeyboardArrowDownIcon fontSize="small" />
                    </IconButton>
                    {p.hasPrinted && (
                      <Tooltip title="A QR code has been printed for this product">
                        <IconButton
                          id="tour-printed-icon"
                          size="small"
                          style={{ color: '#3949ab', marginLeft: 2 }}
                          disableRipple
                        >
                          <PrintIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                    {p.hasDuplicate && (
                      <Tooltip title={`Potential duplicate detected (${p.dupScore}% match) — click to review`}>
                        <IconButton
                          id={p.id === '1' ? 'tour-dup-warning-icon' : undefined}
                          size="small"
                          style={{ color: '#f57c00', marginLeft: 2 }}
                          disableRipple
                        >
                          <WarningIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                  {COLUMNS.map((c) => (
                    <TableCell key={c.key} className={classes.cell}>{p[c.key]}</TableCell>
                  ))}
                  <TableCell className={classes.cell}>
                    <Button variant="contained" size="small" disabled style={{ fontSize: 11 }}>
                      VIEW
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* ── Mock expanded panel for the first row (discontinue tour) ── */}
        <div style={{ padding: '12px 20px 20px', backgroundColor: '#fafafa' }}>
          <Typography variant="caption" style={{ color: '#777' }}>
            Expanded details — P&apos;ZAZZ FIELD TILE FLOOR 12X12 GROUP 1
          </Typography>
          <div style={{ margin: '8px 0' }}>
            <Button variant="contained" size="small" disabled style={{ fontSize: 11 }}>
              SAVE PRICES
            </Button>
            {/* Not `disabled` (unlike the other mock buttons) so it carries the same
                grey/orange treatment the real button has (row__discontinue-btn). */}
            <Button
              id="tour-mock-discontinue-product"
              variant="contained"
              size="small"
              disableRipple
              style={{
                fontSize: 11,
                marginLeft: 8,
                backgroundColor: '#eeeeee',
                color: '#ff682c',
              }}
            >
              DISCONTINUE PRODUCT
            </Button>
          </div>

          {/* Bulk price bar — shown here permanently so the bulk-pricing tour has
              something to point at; in the real panel it appears in Edit Prices mode. */}
          <div className={classes.bulkBar} id="tour-mock-bulk-price">
            <span>Set all SKUs to $</span>
            <span className={classes.qtyChip} style={{ minWidth: 56 }}>6.99</span>
            <Button
              variant="contained"
              size="small"
              disableRipple
              style={{ fontSize: 11, backgroundColor: '#eeeeee', color: '#ff682c' }}
            >
              APPLY TO ALL
            </Button>
            <Button
              variant="contained"
              size="small"
              disableRipple
              style={{ fontSize: 11, backgroundColor: '#eeeeee', color: '#6b6b6b' }}
            >
              CLEAR ALL
            </Button>
            <span style={{ color: '#777', fontSize: 12 }}>
              Fills every override below — adjust any row before saving.
            </span>
          </div>

          <Table size="small">
            <TableHead>
              <TableRow>
                {['SKU', 'Color', 'Price', 'Override', 'UOM', 'Status'].map((label) => (
                  <TableCell key={label} className={classes.cell} style={{ fontWeight: 700 }}>
                    {label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {MOCK_OPTIONS.map((o, i) => (
                <TableRow key={o.sku}>
                  <TableCell className={classes.cell}>{o.sku}</TableCell>
                  <TableCell className={classes.cell}>{o.color}</TableCell>
                  <TableCell className={classes.cell}>{o.price}</TableCell>
                  <TableCell className={classes.cell}>
                    <span className={classes.qtyChip} style={{ minWidth: 56 }}>
                      {o.override}
                    </span>
                  </TableCell>
                  <TableCell className={classes.cell}>{o.uom}</TableCell>
                  <TableCell className={classes.iconCell}>
                    {o.discontinued && (
                      <Tooltip title={`Discontinued ${o.endDate}`}>
                        <InfoIcon color="secondary" style={{ verticalAlign: 'middle' }} />
                      </Tooltip>
                    )}
                    <Button
                      // Anchor the tour on the first still-active option.
                      id={i === 0 ? 'tour-mock-discontinue-option' : undefined}
                      variant="contained"
                      size="small"
                      disableRipple
                      style={{
                        fontSize: 11,
                        marginLeft: 4,
                        backgroundColor: '#eeeeee',
                        color: o.discontinued ? '#09962a' : '#ff682c',
                      }}
                    >
                      {o.discontinued ? 'REACTIVATE' : 'DISCONTINUE'}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Paper>

      {/* ── Mock sample checkout dialog ──
          The real feature is a dialog opened from a product page, so the tour mocks
          it as one rather than as a panel bolted onto this page. Opened by the
          'tour-multi-sample' branch above, just like the merge dialog below. */}
      <Dialog open={checkoutDialogOpen} fullWidth maxWidth="lg">
        <div style={{ padding: 15 }}>
          <Typography variant="h4" style={{ display: 'inline-block', verticalAlign: 'middle', color: '#28C4FC' }}>
            Sample Checkout
          </Typography>
          <div style={{ display: 'inline-block', verticalAlign: 'middle', float: 'right' }}>
            <Button variant="outlined" disableRipple>X</Button>
          </div>
        </div>

        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={5} lg={4}>
              <Typography variant="h5" style={{ marginBottom: 12 }}>Guest Checkout</Typography>

              {['Jordan Avery', 'jordan.avery@gmail.com', '(972) 555-0148'].map((value, i) => (
                <div key={value} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                  {[<PersonIcon key="p" />, <EmailIcon key="e" />, <PhoneIcon key="h" />][i]}
                  <div style={{ flex: 1, borderBottom: '1px solid rgba(0,0,0,0.42)', paddingBottom: 4, fontSize: 15 }}>
                    {value}
                  </div>
                </div>
              ))}

              <div id="tour-mock-multi-sample" style={{ marginTop: 18 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', borderBottom: '1px solid #dfe5e9', paddingBottom: 6 }}>
                  <span style={{ fontWeight: 600 }}>Samples to check out</span>
                  <span style={{ color: '#6d7f89', fontSize: 12 }}>3 selected</span>
                </div>

                {[
                  { product: 'Shaw Anderson Tuftex Oak', colors: ['Natural Hickory', 'Coastal Grey'] },
                  { product: 'Daltile Emerson Wood', colors: ['Butter Pecan'] },
                ].map((group) => (
                  <div key={group.product} style={{ border: '1px solid #dfe5e9', borderRadius: 4, margin: '8px 0px' }}>
                    <div style={{ backgroundColor: '#f7fafb', borderBottom: '1px solid #dfe5e9', padding: '6px 10px', fontSize: 13, fontWeight: 600 }}>
                      {group.product}
                    </div>
                    {group.colors.map((color) => (
                      <div key={color} style={{ display: 'flex', alignItems: 'center', padding: '5px 10px', fontSize: 13 }}>
                        <span style={{ flex: 1 }}>{color}</span>
                        <span style={{ color: '#97a5ac' }}>✕</span>
                      </div>
                    ))}
                  </div>
                ))}

                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                  <Button
                    variant="contained"
                    size="small"
                    disableRipple
                    startIcon={<CropFreeIcon />}
                    style={{ flex: 1, backgroundColor: '#142e3e', color: '#28c4fc' }}
                  >
                    SCAN A SAMPLE
                  </Button>
                  <Button variant="outlined" size="small" disableRipple>
                    THIS PRODUCT
                  </Button>
                </div>
              </div>

              <div style={{ marginTop: 18 }}>
                <Typography variant="caption" style={{ color: '#6d7f89' }}>Reminder Preference</Typography>
                <div style={{ display: 'flex', gap: 16, marginTop: 4 }}>
                  {['Email', 'Phone', 'Both'].map((label) => (
                    <span key={label} style={{ fontSize: 14 }}>
                      <Checkbox checked={label === 'Email'} disabled size="small" style={{ padding: 4 }} />
                      {label}
                    </span>
                  ))}
                </div>
              </div>

              <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
                <Button variant="contained" disableRipple>CLEAR</Button>
                <Button
                  id="tour-mock-sample-submit"
                  variant="contained"
                  disableRipple
                  style={{ flex: 1, backgroundColor: '#4caf50', color: '#FFFFFF' }}
                >
                  CHECK OUT 3 SAMPLES
                </Button>
              </div>
            </Grid>

            <Grid item xs={12} md={7} lg={8}>
              <Typography variant="h5" style={{ margin: '0px 0px 12px' }}>Sample Checkouts</Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {['Name', 'Location', 'Color/Option', 'Status', 'Days'].map((label) => (
                      <TableCell key={label} className={classes.cell} style={{ fontWeight: 700 }}>
                        {label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {MOCK_CHECKOUTS.map((row) => (
                    <TableRow key={row.name + row.color}>
                      <TableCell className={classes.cell}>{row.name}</TableCell>
                      <TableCell className={classes.cell}>{row.location}</TableCell>
                      <TableCell className={classes.cell}>{row.color}</TableCell>
                      <TableCell className={classes.cell}>{row.status}</TableCell>
                      <TableCell className={classes.cell}>{row.days}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* ── Mock duplicate merge review dialog ── */}
      <Dialog open={dupDialogOpen} fullWidth maxWidth="xl">
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <Typography variant="h6" style={{ color: '#fff' }}>
            Review &amp; Merge Products
          </Typography>
          <Button variant="outlined" size="small" style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.5)' }} disabled>
            X
          </Button>
        </DialogTitle>

        <DialogContent dividers style={{ padding: 20 }}>
          {/* Score bar */}
          <div className={classes.scoreBar}>
            {MERGE_SCORES.map(([label, score]) => (
              <span key={label} className={classes.scoreChip}>
                <span className={classes.scoreLabel}>{label}</span>
                {score}%
              </span>
            ))}
          </div>

          {/* Two product cards */}
          <Grid container spacing={2}>
            {/* Product A — shown as selected (blue border) */}
            <Grid item xs={12} md={6}>
              <Paper
                id="tour-dup-card-a"
                elevation={4}
                className={classes.cardSelected}
                style={{ borderRadius: 8, overflow: 'hidden' }}
              >
                <div className={classes.cardHeader} style={{ background: '#1565C0' }}>
                  <div>
                    <Typography style={{ color: '#fff', fontWeight: 700 }}>DALTILE</Typography>
                    <Typography style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>
                      Last modified: 2025-03-15
                    </Typography>
                  </div>
                  <Button variant="outlined" size="small" style={{ color: '#fff', borderColor: '#fff', fontSize: 11 }} disabled>
                    ✓ Keeping this record
                  </Button>
                </div>
                <div style={{ padding: '0 16px 16px' }}>
                  {PRODUCT_A_FIELDS.map(([label, value]) => (
                    <div key={label} className={classes.fieldRow}>
                      <div className={classes.fieldLabel}>{label}</div>
                      <Typography variant="body2">{value}</Typography>
                    </div>
                  ))}
                </div>
              </Paper>
            </Grid>

            {/* Product B — unselected */}
            <Grid item xs={12} md={6}>
              <Paper elevation={1} style={{ borderRadius: 8, overflow: 'hidden', border: '2px solid transparent' }}>
                <div className={classes.cardHeader} style={{ background: '#546e7a' }}>
                  <div>
                    <Typography style={{ color: '#fff', fontWeight: 700 }}>DALTILE</Typography>
                    <Typography style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>
                      Last modified: 2024-11-02
                    </Typography>
                  </div>
                  <Button variant="outlined" size="small" style={{ color: '#fff', borderColor: '#fff', fontSize: 11 }} disabled>
                    Keep this record
                  </Button>
                </div>
                <div style={{ padding: '0 16px 16px' }}>
                  {PRODUCT_B_FIELDS.map(([label, value]) => (
                    <div key={label} className={classes.fieldRow}>
                      <div className={classes.fieldLabel}>{label}</div>
                      <Typography variant="body2">{value}</Typography>
                    </div>
                  ))}
                </div>
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions style={{ padding: '12px 20px' }} id="tour-dup-merge-btn">
          <Button variant="outlined" disabled>Cancel</Button>
          <Button variant="outlined" disabled>Not a Duplicate</Button>
          <Button
            variant="contained"
            disabled
            style={{ backgroundColor: '#FF682C', color: '#fff', marginLeft: 8 }}
          >
            Confirm Merge
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
